'use client'

// Where the island lands. A drawer that wants one of the privy-hooked
// cards renders a slot; the island portals the real thing into it once
// it's up. Until then, a skeleton in the house style — bars, not
// spinners, so the shape of what's coming is already there.

import { useCallback } from 'react'
import useGameStore from '../../stores/gameStore'
import { Card } from '../ui/Drawer'
import { kawaii } from '../../lib/ui/theme'

export function SkeletonCard({ bars = [88, 58, 74], tall = false }) {
  return (
    <Card className={tall ? 'h-full' : ''}>
      <style>{`@keyframes slot-pulse { 0%, 100% { opacity: .4 } 50% { opacity: .85 } }`}</style>
      {bars.map((w, i) => (
        <div
          key={i}
          style={{
            height: 13,
            width: `${w}%`,
            background: kawaii.creamDeep,
            borderRadius: 8,
            marginBottom: i === bars.length - 1 ? 2 : 11,
            animation: `slot-pulse 1.3s ease ${i * 0.18}s infinite`,
          }}
        />
      ))}
    </Card>
  )
}

export function AuthSlot({ kind, skeleton = null, className = '' }) {
  const setAuthSlot = useGameStore((s) => s.setAuthSlot)
  const ready = useGameStore((s) => s.authReady)
  const filled = useGameStore((s) => !!s.authSlots[kind])
  // Callback ref: fires with the node on mount, null on unmount, which is
  // exactly the lifecycle the island needs to place and remove the portal.
  const ref = useCallback((el) => setAuthSlot(kind, el), [kind, setAuthSlot])
  return (
    <div className={className}>
      <div ref={ref} className={className ? 'h-full' : ''} />
      {(!ready || !filled) && skeleton}
    </div>
  )
}
